import React, { useEffect } from "react";
import { Route, Routes, useNavigate, Outlet, Navigate } from "react-router-dom";

import { useSelector } from "react-redux";

import Batch from "./Batch";
import Notice from "./Notice";
import NoticeWrite from "./Notice/Write";
import NoticeDetail from "./Notice/Detail";
import MasterTable from "./MasterTable";
import UserAuth from "./UserAuth";
import OwnerChg from "./OwnerChg";
import DescTemp from "./DescTemp";

import AuditTrail from "./AuditTrail";
import InterfaceStatus from "./InterfaceStatus";

const App = () => {
    const userSelector = useSelector((store) => store.user);
    const common = useSelector((store) => store.common);
    const internal = common.external === "false";

    let RootPage;
    if (userSelector.isAdmin) {
        RootPage = <UserAuth />;
    } else if (userSelector.isSuperVisor) {
        RootPage = <OwnerChg />;
    } else {
        RootPage = (
            <div className={"bpl-container text-center"}>
                <h2>Access Denied</h2>
                <i>Somthing went wrong OR you don't have permission.</i>
            </div>
        );
    }

    if (!internal) {
        return <Navigate replace to={"/error/404"} />
    } else {
        return (
            <>
                {/* <AdminLeft /> */}
                <Routes>
                    <Route path="/" element={RootPage} />
                    <Route path="/masterTable" element={<MasterTable />} />
                    <Route path="/descTemp" element={<DescTemp />} />
                    <Route element={<AuthCheckRouter auth={["99","0"]} />}>
                        <Route path="/userAuth" element={<UserAuth />} />
                        <Route path="/batch" element={<Batch />} />
                        <Route path="/notice" element={<Notice />} />
                        <Route path="/write" element={<NoticeWrite />} />
                        <Route path="/write/:noticeId" element={<NoticeWrite />} />
                        <Route path="/notice/:notice" element={<NoticeDetail />} />

                        <Route path="/audit-trail" element={<AuditTrail />} />
                        <Route path="/InterfaceStatus" element={<InterfaceStatus />} />
                    </Route>
                    <Route element={<AuthCheckRouter auth={["4","0","99"]} />}>
                        <Route path="/ownerChg" element={<OwnerChg />} />
                    </Route>

                    <Route path="*" element={<Navigate replace to={"/error/404"} />} />
                </Routes>
            </>
        );
    }
};

const AuthCheckRouter = (props, ref) => {
    const userSelector = useSelector((store) => store.user);
    const check = userSelector?.userAuth?.filter((auth) => props?.auth?.includes(auth.code.toString()));

    if (check.length > 0) {
        return <Outlet />;
    } else {
        return (
            <div className={"bpl-container text-center"}>
                <h2>Access Denied</h2>
                <i>Somthing went wrong OR you don't have permission.</i>
            </div>
        );
    }
};

export default App;
